<template>
    <div>
        <p id="titleName">
            <span style="color:#00A5D5;">{{ secTitle }}</span>
            <span v-if="content != ''">（{{ content }}）</span>
        </p>
        <!-- 上传文件入口 -->
        <div class="orderUpload">
            <el-upload v-for="(item, i) in list" :key="i" drag action :show-file-list="false" :class="`upload-${i}`"
                :before-upload="handleChange" :http-request="uploadFile"
                :data="{ objectType: dataType, objectTag: '', index: i }" :auto-upload="true">
                <img v-if="dataList[i]" :src="dataList[i]" class="avatar" style="width:100%;height:100%;">
                <div v-else>
                    <i class="el-icon-plus uploadIcon"></i>
                    <div class="el-upload__text"><em>{{ item.label }}</em></div>
                </div>
            </el-upload>
        </div>
        <h2 id="example" @click="isShow = !isShow">示例
        </h2>
        <!-- 示例图片： -->
        <transition name="el-fade-in-linear">
            <div class="item" v-show="isShow">
                <div class="example">
                    <el-image :src="list[0].imgUrl" class="boneToothImg"></el-image>
                    <el-image :src="list[1].imgUrl" class="boneImg"></el-image>
                    <img class="copyright" src="/static/images/orthodontics/smiling-orthodontics.jpg">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import EleUploadImage from "vue-ele-upload-image";
import BaseTag from '../../../components/BaseTag'
import {
    uploadByPieces
} from "../../../../common/upload.js";

export default {
    data() {
        return {
            fileList: [],
            dataList: [],
            imageUrl: '',
            distance: 0,//图片盒子间距
            uploadDistance: 0,//图片上传框间距
            titleName: '',
            secTitle: '',
            content: '',
            isShow: false,//是否显示示例图片
            dataVideo: [],
        }
    },
    props: {
        subCatalogId: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default() {
                return {}
            }
        },
        currentStep: {
            type: Number,
            default: 0
        },
        dataType: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleChange(label) {
            const isImageByType  = label.type.startsWith('image/');
            const isImageByExt = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp', 'ico'].includes(label.name.split('.').pop().toLowerCase());
            const isImage = isImageByType || isImageByExt;
            if (!isImage) {
                this.$message.error('只能上传图片文件!');
                return false;
            }
        },
        uploadFile({ response, file, data }) {
            // console.log('res:', response, 'file:', file, 'data:', data)
            var loading = this.$loading({ text: '等待上传完成，已上传0%' })
            var that = this
            uploadByPieces({
                file: file,//文件
                data: data,
                pieceSize: 3,
                concurrent: 3,
                process: res => {
                    loading.setText('等待上传完成，已上传' + res + '%')
                    if (res == 100) {
                        loading.close();
                    }
                },
                success: res => {
                    let temp = {
                        id: data.index,
                        url: res.data.url
                    }
                    this.fileList[data.index] = temp;
                    sessionStorage.setItem('dataVideoList', JSON.stringify(this.fileList));
                    let arr = []
                    if(this.dataList!=[]){
                        arr = this.dataList
                        if(temp.id=='0'){
                            let temp2 = {
                                id: '1',
                                url: arr[1]
                            }
                            this.fileList[1] = temp2
                        }else{
                            let temp2 = {
                                id: '0',
                                url: arr[0]
                            }
                            this.fileList[0] = temp2
                        }
                    }else{
                        this.dataList = this.fileList;
                    }
                    loading.close();
                    this.$nextTick(() => {
                        this.dataList = this.fileList.map(item => {
                            if (item !== null) {
                                return item.url || ''
                            }
                        });
                        this.transFile();
                    })
                },
                error: e => {
                    console.log('e', e)
                }
            })
        },
        transFile() {
            this.$emit('transFile', this.dataList, this.dataType)
        },
        beforeRemove() {

        },
        handleExceed() {

        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        handlePictureCardPreview() {

        },
        handleRemove() {

        },
        showStr() {
            this.titleName = '隐形矫治';
            if (this.currentStep == 5) {
                this.secTitle = '影像资料';
                this.content = '头颅侧位片拍摄位置要求：最大牙尖交错位。';
            }
        },
        transFile() {
            this.$emit('transFile', this.dataList, this.dataType)
        },
        loadSessionFile(){
            if (sessionStorage.getItem('dataVideoList')) {
                this.fileList = JSON.parse(sessionStorage.getItem('dataVideoList'));
                console.log('session',this.fileList)
                this.dataList = this.fileList.map(item => {
                    if (item !== null) {
                        if(item.url==undefined){
                            // 修改订单时读取的图片路径
                            return item;
                        }
                        // 下单读取的图片对象的url
                        return item.url || '';
                    }
                });
            }
            //    this.transFile();
        },
    },
    watch: {
        currentStep(oldVal, newVal) {
            this.showStr()
        }
    },
    created() {
    },
    mounted() {
        this.showStr()
        this.loadSessionFile();
    },
    components: {
        EleUploadImage,
        BaseTag
    }
}
</script>
<style lang="scss" scoped>
#titleName {
    font-size: 15px;
    font-weight: 500;
    margin: 10px 0 0 20px;
}


.orderUpload {
    height: 200px;
    margin-top: 20px;
    display: flex;
}

/* create上传 */

.item {
    width: auto;
    height: 220px;
    margin: 0 auto;
    display: flex;
}

#example {
    font-size: 18px;
    font-weight: 700;
    color: #00A5D5;
    margin: 10px 0 20px 68%;
}

.example {
    position: relative;
    justify-content: space-between;
    .boneToothImg{
        width:680px;
        height:220px;
        margin:0 50px 0 100px;
    }
    .boneImg{
        width:220px;
        height:220px;
    }
    .copyright{
        width: 30px;
        height: 30px;
        position: absolute;
        bottom: 0.5%;
        right: 18%;

        z-index: 99;
    }
}
</style>
<style>
.upload0 .el-upload--picture-card:nth-of-type(1) {
    width: 700px !important;
    height: 190px !important;
    border-radius: 20px;
    margin-left: 90px;
}

.upload1 .el-upload--picture-card:nth-of-type(1) {
    width: 250px !important;
    height: 190px !important;
    border-radius: 20px;
    margin-left: 28px;
}

.uplaod1,
.upload0 .el-icon-plus:before {
    line-height: 6;
}

.title-name {
    font-size: 25px;
}

.uploadIcon {
    font-size: 30px;
    margin-top: 70px;
    margin-bottom: 30px;
}
</style>
<style>
/* .el-upload-dragger{
    width:700px;
    height: 190px;
    margin-left: var(--marginLeft);
} */
.upload-0 .el-upload-dragger {
    width: 680px !important;
    height: 190px;
    margin: 0 50px 0 14%;
}

.upload-1 .el-upload-dragger {
    width: 225px;
    height: 190px;
    margin-left: 45%;
}

.avatar {
    /* background-size: cover; */
    /* width: 680px; */
    /* height: 260px; */
    object-fit: contain;
    object-position: top;
}
</style>


// WEBPACK FOOTER //
// boneUploadImg.vue?449d7322